module.exports = __webpack_public_path__ + "static/thank-you-a21daa5788a7c12c0873129acb160c15.png";